export default __webpack_public_path__ + "static/media/no_plan_illustration.87455532.svg";